// extracted by mini-css-extract-plugin
export default {"container":"Fr-z","brandName":"Gr-z","productName":"Hr-z","productNamePdpEnhancements":"Ir-z","breakLongProductName":"Jr-z"};